import React from 'react';
import { AppBar, Toolbar, Button, Divider } from '@mui/material';
import { Menu, MenuItem } from '@mui/material';
import { FcHome } from 'react-icons/fc'
import { Link } from 'react-router-dom'
import { useRouteMatch } from 'react-router-dom';
import { SlArrowDown } from "react-icons/sl";
import { getDocumentByFileStoreId } from '@egovernments/digit-ui-libraries/src/utils/fileType';
import { useState } from 'react';

const Navbar = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorE2, setAnchorE2] = useState(null);
  const [anchorE3, setAnchorE3] = useState(null);
  const [anchorE4, setAnchorE4] = useState(null);
  const [anchorE5, setAnchorE5] = useState(null);
  const [anchorE6, setAnchorE6] = useState(null);
  const [anchorE7, setAnchorE7] = useState(null);
  const [anchorE8, setAnchorE8] = useState(null);
  const [anchorE9, setAnchorE9] = useState(null);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);


  const { path } = useRouteMatch();

  const handleClickAboutUs = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClickRegulation = (event) => {
    setAnchorE2(event.currentTarget)
  }
  const handleClickNotifications = (event) => {
    setAnchorE3(event.currentTarget)
  }
  const handleActRules = (event) => {
    setAnchorE4(event.currentTarget)
  }
  const handleMedia = (event) => {
    setAnchorE5(event.currentTarget)
  }
  const handleTutorial = (event) => {
    setAnchorE9(event.currentTarget)
  }
  const handleClickGenral = (event) => {
    setAnchorE6(event.currentTarget)
  }
  const handleClickUserManual = (event) => {
    setAnchorE7(event.currentTarget)
  }
  const handleClickForm12 = (event) => {
    setAnchorE8(event.currentTarget)
  }
  const handleClickForm26 = (event) => {
    return null
  }
  const handleClickForm11 = (event) => {
    return null
  }

  const handleClose = () => {
    setAnchorEl(null);
    setAnchorE2(null)
    setAnchorE3(null);
    setAnchorE4(null)
    setAnchorE5(null);
    setAnchorE6(null);
    setAnchorE7(null)
    setAnchorE8(null)
  };

  return (
    <AppBar position="static" style={{ background: '#1F4A7C', height: '44px' }} >
      <Toolbar>
        <Button LinkComponent={Link} to='/digit-ui/citizen' color='inherit' style={{ marginLeft: '70px', marginBottom: '18px', fontSize: '12px', color: 'white' }}><FcHome style={{ width: '30px', height: '30px' }} /></Button>
        <Button color="inherit" onClick={handleClickAboutUs} style={{ marginLeft: '30px', marginBottom: '18px', fontSize: '12px', color: 'white' }}>About Us<span style={{ marginLeft: '5px' }}><SlArrowDown /></span></Button>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          PaperProps={{
            style: {
              backgroundColor: '#1F4A7C',
              padding: '10px'
            }
          }}
        >
          <MenuItem onClick={handleClose} style={{ color: '#fff', fontSize: '12px' }}>
            <Link style={{ textDecoration: 'none', color: '#fff' }} to={`/digit-ui/citizen/objectives`}>
              OBJECTIVE
            </Link>
          </MenuItem>
          <Divider />
          <MenuItem onClick={handleClose} style={{ color: '#fff', fontSize: '12px' }}>
            <Link style={{ textDecoration: 'none', color: '#fff' }} to='/digit-ui/citizen/organizational-setup'>
              ORGANIZATIONAL SETUP
            </Link>
          </MenuItem>
          <Divider />
          <MenuItem onClick={handleClose} style={{ color: '#fff', fontSize: '12px' }}>
            <Link style={{ textDecoration: 'none', color: '#fff' }} to='/digit-ui/citizen/contact-us'>
              CONTACT US
            </Link>
          </MenuItem>
          <Divider />
          <MenuItem onClick={handleClose} style={{ color: '#fff', fontSize: '12px' }}>
            <Link style={{ textDecoration: 'none', color: '#fff' }} to='/digit-ui/citizen/employee-profile'>
              EMPLOYEE PROFILE
            </Link>
          </MenuItem>
          <Divider />
          <MenuItem onClick={handleClose} style={{ color: '#fff', fontSize: '12px' }}>
            <Link style={{ textDecoration: 'none', color: '#fff' }} to='/digit-ui/citizen/ex-employee-profile'>
              EX-EMPLOYEE PROFILE
            </Link>
          </MenuItem>
        </Menu>
        <Button color="inherit" onClick={handleClickRegulation} style={{ marginLeft: '30px', marginBottom: '18px', color: 'white' }}>Planning Regulations<span style={{ marginLeft: '5px' }}><SlArrowDown /></span></Button>
        <Menu
          anchorEl={anchorE2}
          open={Boolean(anchorE2)}
          onClose={handleClose}
          PaperProps={{
            style: {
              backgroundColor: '#1F4A7C',
              padding: '10px'
            }
          }}
        >
          <Button color='inherit' onClick={handleClickGenral} style={{ color: '#fff', fontSize: '12px' }}>GENERAL<span style={{ marginLeft: '200px' }}>{'>'}</span></Button>
          <Menu
            anchorEl={anchorE6}
            open={Boolean(anchorE6)}
            onClose={handleClose}
            PaperProps={{
              style: {
                backgroundColor: '#1F4A7C',
                width: '150px',
                height: '100px',
                margin: '-40px 0px 0px 253px',
                padding: '10px'
              }
            }}
          >
            <MenuItem onClick={handleClose} style={{ color: '#fff', fontSize: '12px' }}>
              <Link style={{ textDecoration: 'none', color: '#fff' }} to='/digit-ui/citizen/appendix-1'>
                APPENDIX-1
              </Link>
            </MenuItem>
            <Divider />
            <MenuItem onClick={handleClose} style={{ color: '#fff', fontSize: '12px' }}>
              <Link style={{ textDecoration: 'none', color: '#fff' }} to='/digit-ui/citizen/appendix-8'>
                APPENDIX-8
              </Link>
            </MenuItem>
          </Menu>
          <Divider />
          <MenuItem onClick={handleClose} style={{ color: '#fff', fontSize: '12px' }}>
            <Link style={{ textDecoration: 'none', color: '#fff' }} to='/digit-ui/citizen/apartment-colonies-regulation'>
              APARTMENT/COLONIES REGULATION
            </Link>
          </MenuItem>
        </Menu>
        <Link to="/digit-ui/citizen/development-plan" style={{ textDecoration: 'none' }}>
          <Button color="inherit" style={{ marginLeft: '30px', marginBottom: '18px', fontSize: '12px', color: 'white' }}>
            Development Plan
          </Button>
        </Link>
        <Button color="inherit" onClick={handleClickUserManual} style={{ marginLeft: '30px', marginBottom: '18px', color: 'white' }}>User Manual <span style={{ marginLeft: '5px' }}><SlArrowDown /></span></Button>
        <Menu
          anchorEl={anchorE7}
          open={Boolean(anchorE7)}
          onClose={handleClose}
          PaperProps={{
            style: {
              backgroundColor: '#1F4A7C'
            }
          }}
        >
          <Button color='inherit' onClick={handleClickForm12} style={{ color: '#fff', fontSize: '12px' }}>Form12<span style={{ marginLeft: '100px' }}>{'>'}</span></Button>
          <Menu
            anchorEl={anchorE8}
            open={Boolean(anchorE8)}
            onClose={handleClose}
            PaperProps={{
              style: {
                backgroundColor: '#1F4A7C',
                width: '250px',
                height: '150px',
                margin: '-40px 0px 0px 170px',
                padding: '20px',
                overflow: 'hidden'
              }
            }}
          >
            <MenuItem onClick={() => getDocumentByFileStoreId("171f71f5-efe7-476d-835d-6e673d935f2e", setIsPreviewLoading)} style={{ color: '#fff', fontSize: '12px' }}>
              USER MANUAL FOR OBPS
            </MenuItem>
            <Divider />
            <MenuItem onClick={handleClose} style={{ color: '#fff', fontSize: '12px' }}>
              <a href="https://hptcp.hp.gov.in/edcr/rest/dcr/downloadfile?tenantId=hp&fileStoreId=f115810c-681f-4519-91e1-86f58a39b273" target="_blank" style={{ textDecoration: 'none', color: '#fff' }}>
                Sample Drawing for Residential 
              </a>
            </MenuItem>
            {/* <Divider />
            <MenuItem onClick={handleClose} style={{ color: '#fff', fontSize: '12px' }}>
              <a href="https://hptcp.hp.gov.in/edcr/rest/dcr/downloadfile?tenantId=hp&fileStoreId=6a5f395e-5db7-4753-8744-fb649289f26f" target="_blank" style={{ textDecoration: 'none', color: '#fff' }}>
                Sample Drawing for Residential - 2
              </a>
            </MenuItem> */}
            {/* <Divider />
            <MenuItem onClick={handleClose} style={{ color: '#fff', fontSize: '12px' }}>
              <a href="https://hptcp.hp.gov.in/edcr/rest/dcr/downloadfile?tenantId=hp&fileStoreId=d5e11115-bfbd-4687-ab1c-eb1b888d6857" target="_blank" style={{ textDecoration: 'none', color: '#fff' }}>
                Sample Drawing for Residential - 3
              </a>
            </MenuItem> */}
            <Divider />
            <MenuItem onClick={handleClose} style={{ color: '#fff', fontSize: '12px' }}>
            <a href="https://hptcp.hp.gov.in/edcr/rest/dcr/downloadfile?tenantId=hp&fileStoreId=e6cef4d6-23cb-41ea-b06f-d7e4ee1db3d4" target="_blank" style={{ textDecoration: 'none', color: '#fff' }}>
              Sample Drawing for Commercial            
            </a>
          </MenuItem>
          </Menu>
          <Divider />
          <Button color='inherit' onClick={() => getDocumentByFileStoreId("3bf23245-1112-46d6-b51b-acdfd0dae3cd", setIsPreviewLoading)} style={{ color: '#fff', fontSize: '12px' }}>Form11<span style={{ marginLeft: '100px' }}>{'>'}</span></Button>
          <Divider />
          <Button color='inherit' onClick={() => getDocumentByFileStoreId("4aa92862-cae2-4423-b0d8-3eb07549e74f", setIsPreviewLoading)} style={{ color: '#fff', fontSize: '12px' }}>
            Form26
            <span style={{ marginLeft: '100px' }}>{'>'}</span>
          </Button>
          <Divider />
          <Button color='inherit' onClick={() => getDocumentByFileStoreId("3c0512c1-2aff-419b-aa10-1333a15ea3eb", setIsPreviewLoading)} style={{ color: '#fff', fontSize: '12px' }}>
            Form CLU
            <span style={{ marginLeft: '100px' }}>{'>'}</span>
          </Button>
          <Divider />
          <Button color='inherit' onClick={() => getDocumentByFileStoreId("9e1a9c1e-b22e-4887-9564-59605064e4f6", setIsPreviewLoading)} style={{ color: '#fff', fontSize: '12px' }}>
            Mobile Tower Application
          </Button>
        </Menu>

        {/* <Button color="inherit" onClick={() => window.location('/development-plan')} style={{marginLeft: '30px', marginBottom: '18px', fontSize: '12px', color: 'white'}}>Development Plan</Button> */}
        <Button color='inherit' onClick={handleClickNotifications} style={{ marginLeft: '30px', marginBottom: '18px', fontSize: '12px', color: 'white' }}>Notifications / Orders <span style={{ marginLeft: '5px' }}><SlArrowDown /></span></Button>
        <Menu
          anchorEl={anchorE3}
          open={Boolean(anchorE3)}
          onClose={handleClose}
          PaperProps={{
            style: {
              backgroundColor: '#1F4A7C',
              padding: '10px'
            }
          }}
        >
          <MenuItem onClick={handleClose} style={{ color: '#fff', fontSize: '12px' }}>
            <Link style={{ textDecoration: 'none', color: '#fff' }} to='/digit-ui/citizen/court-orders'>
              COURT ORDERS
            </Link>
          </MenuItem>
          <Divider />
          <MenuItem onClick={handleClose} style={{ color: '#fff', fontSize: '12px' }}>
            <Link style={{ textDecoration: 'none', color: '#fff' }} to='/digit-ui/citizen/notifications-under-tcp-act'>
              NOTIFICATIONS UNDER TCP ACT
            </Link>
          </MenuItem>
          <Divider />
          <MenuItem onClick={handleClose} style={{ color: '#fff', fontSize: '12px' }}>
            <Link style={{ textDecoration: 'none', color: '#fff' }} to='/digit-ui/citizen/service-matter'>
              SERVICE MATTER
            </Link>
          </MenuItem>
        </Menu>
        <Button color='inherit' onClick={handleActRules} style={{ marginLeft: '30px', marginBottom: '18px', fontSize: '12px', color: 'white' }}>Act & Rules</Button>
        <Menu
          anchorEl={anchorE4}
          open={Boolean(anchorE4)}
          onClose={handleClose}
          PaperProps={{
            style: {
              backgroundColor: '#1F4A7C',
              padding:'10px'
            }
          }}
        >
          <MenuItem onClick={handleClose} style={{ color: '#fff', fontSize: '12px' }}>
            <Link style={{ textDecoration: 'none', color: '#fff' }} to='/digit-ui/citizen/delegation-of-powers'>
              DELEGATION OF POWER
            </Link>
          </MenuItem>
        </Menu>
        <Button color="inherit" onClick={handleMedia} style={{ marginLeft: '30px', marginBottom: '18px', fontSize: '12px', color: 'white' }}>Media <span style={{ marginLeft: '5px' }}><SlArrowDown /></span></Button>
        <Menu
          anchorEl={anchorE5}
          open={Boolean(anchorE5)}
          onClose={handleClose}
          PaperProps={{
            style: {
              backgroundColor: '#1F4A7C', 
              padding: '10px'
            }
          }}
        >
          <MenuItem onClick={handleClose} style={{ color: '#fff', fontSize: '12px' }}>
            <Link style={{ textDecoration: 'none', color: '#fff' }} to='/digit-ui/citizen/photo-gallery'>
              PHOTO GALLERY
            </Link>
          </MenuItem>
          <Divider />
          <MenuItem onClick={handleClose} style={{ color: '#fff', fontSize: '12px' }}>
            <Link style={{ textDecoration: 'none', color: '#fff' }} to='/digit-ui/citizen/video-gallery'>
              VIDEO GALLERY
            </Link>
          </MenuItem>
          <Divider />
          <MenuItem onClick={handleClose} style={{ color: '#fff', fontSize: '12px' }}>
            <Link style={{ textDecoration: 'none', color: '#fff' }} to='/digit-ui/citizen/heritage-gallery'>
              HERITAGE GALLERY
            </Link>
          </MenuItem>
        </Menu>
        {/* <Button color="inherit" style={{marginLeft: '30px', marginBottom: '18px',  fontSize: '12px', color: 'white'}}>RTI</Button> */}
        <Button color="inherit" onClick={handleTutorial} style={{ marginLeft: '30px', marginBottom: '18px', fontSize: '12px', color: 'white' }}>Tutorial Video <span style={{ marginLeft: '5px' }}><SlArrowDown /></span></Button>
        <Menu
          anchorEl={anchorE9}
          open={Boolean(anchorE9)}
          onClose={handleClose}
          PaperProps={{
            style: {
              backgroundColor: '#1F4A7C', 
              padding: '10px'
            }
          }}
        >
          <MenuItem onClick={handleClose} style={{ color: '#fff', fontSize: '12px' }}>
          <a
            href='https://youtu.be/LXQBX2gzypY'
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'none', color: '#fff' }}
          >
            Professional login & DXF Uploading
          </a>
          </MenuItem>
          <Divider />
          <MenuItem onClick={handleClose} style={{ color: '#fff', fontSize: '12px' }}>
          <a
            href='https://youtu.be/6OoOvF63JpY'
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'none', color: '#fff' }}
          >
            Form12 Filling & Structure Certificate Process
          </a>
          </MenuItem>
          <Divider />
          <MenuItem onClick={handleClose} style={{ color: '#fff', fontSize: '12px' }}>
          <a
            href='https://youtu.be/ODczwj0dFEE'
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'none', color: '#fff' }}
          >
            Fee Payment & Self Approval
          </a>
          </MenuItem>
          <Divider />
          <MenuItem onClick={handleClose} style={{ color: '#fff', fontSize: '12px' }}>
          <a
            href='https://youtu.be/p7YjpBXog4w'
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'none', color: '#fff' }}
          >
            EDCR Formatting in CAD Building Plans
          </a>
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar